import { string, date, object, mixed } from "yup";
import { matchIsValidTel } from "mui-tel-input";
import { isDate } from "date-fns";
import dayjs from "dayjs";
import { basicProfilecategory } from "../../../../constants";

const parseDateString = (originalValue) => {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : new Date(dayjs(originalValue));
  return parsedDate;
};

export const validationAddRecruiterSchema = object().shape({
  profileImage: mixed().nullable(),
  firstName: string().required("First name is required"),
  lastName: string().required("Last name is required"),
  mobileNo: string()
    .trim()
    .test(
      "myphone",
      "Invalid mobile no",
      (value) => value?.length < 4 || matchIsValidTel(value)
    ),
  email: string().trim().email("Invalid email id"),
  profileCategoryId: string().required("Profile category is required"),
  location: string(),
  bio: string().trim(),
  gender: string().required("Gender is required"),
  contactVisibility: string(),
  businessEmail: string().trim().email("Invalid email id"),
  businessMobileNo: string()
    .trim()
    .notRequired()
    .test(
      "myphone",
      "Invalid mobile no",
      (value) => value?.length < 4 || matchIsValidTel(value)
    ),
  // dob: date().typeError("Invalid Date of Birth").transform(parseDateString),
  nationality: string(),
  companyName: string().when("profileCategoryId", (value, schema) => {
    const isAgency = value[0]
      ? value[0] !== basicProfilecategory.CASTING_DIRECTOR &&
        value[0] !== basicProfilecategory.COORDINATOR
      : false;
    if (!isAgency) return schema;
  }),
  experienceYears: string().required("Experience year is required"),
  experienceCategory: string().required("Experience Category is required"),
});

export const validationUpdateRecruiterSchema = object().shape({
  gender: string().required("Gender is required"),
  profileCategoryId: string().required("Profile Category is required"),
});
